import styled from 'styled-components'

const WrapFilterStatus = styled.div`
    position: relative;
`
export { WrapFilterStatus }